// extracted by mini-css-extract-plugin
module.exports = {"input":"GoldenInput_input__E9RpI"};